import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell,
  ResponsiveContainer,
} from "recharts";

// Add this function anywhere in BarChartUtils.js
export const getMaxScore = (testName) => {
  const ranges = metrics[testName];
  if (!ranges) return 100; // A sensible default
  
  const allScores = Object.values(ranges);
  return Math.max(...allScores);
};


export const metrics = {
  Anxiety: {
    minimalLow: 0,
    minimalHigh: 4,
    mildLow: 5,
    mildHigh: 9,
    moderateLow: 10,
    moderateHigh: 14,
    severeLow: 15,
    severeHigh: 21,
  },

  ADHD: {
    absentLow: 0,
    absentHigh: 13,
    presentLow: 14,
    presentHigh: 24,
  },

  Depression: {
    minimalLow: 0,
    minimalHigh: 4,
    mildLow: 5,
    mildHigh: 9,
    moderateLow: 10,
    moderateHigh: 14,
    moderatelySevereLow: 15,
    moderatelySevereHigh: 19,
    severeLow: 20,
    severeHigh: 27,
  },

  MentalWellbeing: {
    highLow: 71,
    highHigh: 100,
    mediumLow: 31,
    mediumHigh: 70,
    lowLow: 0,
    lowHigh: 30,
  },
};

export const TestMap = {
    Anxiety: "Anxiety levels",
    ADHD: "ADHD levels",
    Depression: "Depression levels",
    MentalWellbeing: "Mental wellbeing"
  }

export const messages = {
  Anxiety: {
    minimal: "minimal risk",
    mild: "mild risk",
    moderate: "moderate risk",
    severe: "severe risk",
  },
  ADHD: {
    absent: "likely don't have ADHD",
    present: "likely have ADHD",
  },
  Depression: {
    minimal: "minimal risk",
    mild: "mild risk",
    moderate: "moderate risk",
    moderatelySevere: "moderately severe risk",
    severe: "severe risk",
  },
  MentalWellbeing: {
    high: "high",
    medium: "medium",
    low: "low",
  },
};

// orange - CF6C22
// blue -  64AEE2
// green - 458751

export const categoryColors = {
  minimal: "#458751",
  mild: "#458751",
  moderate: "#64AEE2",
  moderatelySevere: "#64AEE2",
  severe: "#CF6C22",
  absent: "#458751",
  present: "#CF6C22",
  low: "#458751",
  medium: "#64AEE2",
  high: "#CF6C22",
};

export const getYAxisTicks = (testName) => {
  const ranges = metrics[testName];
  if (!ranges) return [];

  const ticks = [];
  for (const key in ranges) {
    // We only want the starting point of each range
    if (key.endsWith("High")) {
      ticks.push(ranges[key]);
    }
  }
  // Sort them numerically to ensure correct order on the axis
  return ticks.sort((a, b) => a - b);
};

export function getCategory(testName, score) {
  const ranges = metrics[testName];
  const msgs = messages[testName];

  for (const key in ranges) {
    if (key.endsWith("Low")) {
      const base = key.replace("Low", "");
      const low = ranges[`${base}Low`];
      const high = ranges[`${base}High`];

      if (score >= low && score <= high) {
        return {
          key: base,
          label: msgs[base] || base,
        };
      }
    }
  }

  return { key: "unknown", label: "No category" };
}
